import { Dispatch, SetStateAction } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import {
  DirectoryRoles,
  UserViewRoles,
  isAbleToSeeUIElement,
} from '../../../utils/roles/client-roles';
import SharedToolbar from '../../../shared/shared-toolbar-latest';
import SharedGridStateIconButton from '../../../shared/shared-grid-state-icon-button-latest';
import { ModuleList } from '../../../shared/analytics/module-list';
import CreateButton from '../../../shared/buttons/create-button';
import SharedIconButton from '../../../shared/buttons/shared-icon-button';
interface SharedContactsGridToolbarProps {
  userView?: boolean;
  paginationModel: {
    pageSize: number;
    page: number;
    cursor: string | null;
    search: string;
  };
  setPaginationModel: Dispatch<
    SetStateAction<{
      pageSize: number;
      page: number;
      cursor: string | null;
      search: string;
    }>
  >;
  directoryRoles: string[];
  userViewRoles: string[];
  setOpenAddContacts: Dispatch<SetStateAction<boolean>>;
  setOpenDeleteContacts: Dispatch<SetStateAction<boolean>>;
  selectedRows: string[];
}

export default function SharedContactsGridToolbar({
  userView,
  paginationModel,
  setPaginationModel,
  directoryRoles,
  userViewRoles,
  setOpenAddContacts,
  setOpenDeleteContacts,
  selectedRows,
}: SharedContactsGridToolbarProps) {
  const queryClient = useQueryClient();

  const disabledAddContact = userView
    ? !isAbleToSeeUIElement(
        userViewRoles!,
        UserViewRoles.AddSharedContacts.value
      )
    : !isAbleToSeeUIElement(
        directoryRoles,
        DirectoryRoles.AddSharedContacts.value
      );

  const disabledDeleteContact = userView
    ? !isAbleToSeeUIElement(
        userViewRoles!,
        UserViewRoles.DeleteSharedContacts.value
      )
    : !isAbleToSeeUIElement(
        directoryRoles,
        DirectoryRoles.DeleteSharedContacts.value
      );

  return (
    <SharedToolbar
      noFilter
      quickFilterDebounceMs={300}
      primaryButtons={
        <CreateButton
          disabled={disabledAddContact}
          onClick={() => setOpenAddContacts(true)}
          label="Add Contact"
        />
      }
      secondaryButtons={
        <>
          <SharedIconButton
            variant="delete"
            onClick={() => setOpenDeleteContacts(true)}
            disabled={selectedRows.length === 0 || disabledDeleteContact}
            tooltipLabel="Delete"
          />
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              setPaginationModel({
                page: 0,
                pageSize: paginationModel.pageSize,
                cursor: null,
                search: paginationModel.search,
              });
              void queryClient.invalidateQueries({
                queryKey: ['SharedContacts'],
              });
            }}
            tooltipLabel="Refresh"
          />
          {!userView && (
            <SharedGridStateIconButton
              gridStateKey="sharedContactsGridStates"
              module={ModuleList.modules.directory.name}
              section={ModuleList.modules.directory.sections.sharedContacts}
            />
          )}
        </>
      }
    ></SharedToolbar>
  );
}
